import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs/operators';
import { isTruthy } from 'shared/util-common';

import { UserService } from './user.service';

export const userGuard: CanActivateFn = () => {
  return toObservable(inject(UserService).user).pipe(
    isTruthy(),
    map(() => true),
  );
};
